<div class="modal-header d-flex flex-row align-items-center justify-content-between">
  <div class="d-flex flex-row align-items-center p-2">
    <div class="chip-icon primary small"><div class="inner"><i class="ti ti-filter"></i></div></div>
    <span class="title ms-2">Filtrer</span>
  </div>
  <div class="actions d-flex align-items-center me-3">
    <button class="button s transparent" (click)="resetFilters()">Réinitialiser<i class="ti ti-reload ms-2"></i></button>
  </div>
</div>
<div class="modal-content">
  <div class="d-flex flex-column gap-3 w-100">
    <div class="d-flex flex-column gap-2 form-group w-100" *ngFor="let f of getFilters()">
      <ng-container *ngIf="f.type === 'text'">
        <label>{{ f.label }}</label>
        <input type="text" [placeholder]="filters[f.key].placeholder" [(ngModel)]="filters[f.key].value">
      </ng-container>
      <ng-container *ngIf="f.type === 'date'">
        <label>{{ f.label }}</label>
        <input type="date" [(ngModel)]="filters[f.key].value">
      </ng-container>
      <ng-container *ngIf="f.type === 'boolean'">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <label>{{ f.label }}</label>
          <app-toggle [(ngModel)]="filters[f.key].value"></app-toggle>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<div class="modal-footer d-flex flex-row align-items-center justify-content-end gap-2">
  <button class="button m" (click)="close()" type="button">Annuler</button>
  <button class="button m primary confirm" (click)="close({confirm: true, filters})" type="button">Valider</button>
</div>
